(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('userPasswordAction', {
      controller: Controller,
      templateUrl: 'actions/user/password/password-user.action.html',
      bindings: {
        credentials: '<',
        user: '<',
        then: '&',
        catch: '&'
      }
    });
}());
